// API Configuration
const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:5000';

export default {
  API_BASE_URL
};
